import Link from 'next/link';
import type { PropsWithChildren } from 'react';
import type { GnbItem } from '../gnb-menu';
import { useCustomHackleTrack } from '@/lib/hackle.service';

const NavLink = ({
  children,
  item: { title, path, newTab },
}: PropsWithChildren<{ item: GnbItem }>) => {
  const {
    track,
  } = useCustomHackleTrack();

  if (path) {
    const target = newTab ? '_blank' : '_self';

    return (
      <Link
        href={path}
        target={target}
        onClick={() => {
          title === '시험관리 FAQ' && track({ key: 'certi_guide_faq_clicked' });
        }}
      >
        {children}
      </Link>
    );
  }

  return <span>{children}</span>;
};

export default NavLink;
